import { IOptionSelectionHelper } from '@/helpers/IOptionSelectionHelper'
import { ProductApiModel } from '@/interfaces/ProductApiModel'
import { OptionApiModel } from '@/interfaces/OptionApiModel'
import lodash from 'lodash'
import Vue from 'vue'
import { OptionSelectionHelper } from '@/helpers/OptionSelectionHelper'

export class ModelOptionSelectionHelper implements IOptionSelectionHelper {
  private helper: OptionSelectionHelper;

  constructor(private model: ProductApiModel) {
    this.helper = new OptionSelectionHelper(this.toggleUpdating, this.updateModelProperty,
      this.removeModelPropertyOption, this.addModelPropertyOption, this.showConfirmDeselect, model)
  }

  protected showConfirmDeselect() {
    return Promise.resolve(true)
  }

  protected toggleUpdating() {
    return false
  }

  public async selectOption(optionItem: OptionApiModel, forceDeselection = false): Promise<void> {
    await this.helper.selectOption(optionItem, forceDeselection)
  }

  public async deselectOption(optionItem: OptionApiModel, forceDeselection = false,
    skipDependencies = false) {
    await this.helper.deselectOption(optionItem, forceDeselection, skipDependencies)
  }

  public removeModelPropertyOption(payload: { property: string; value: string }): void {
    this.setPropOption({ ...payload, ...{ action: 'remove' } })
  }

  public updateModelProperty(payload: { property: string; value: any }): void {
    Vue.set(this.model.configurator, payload.property, payload.value)
  }

  public addModelPropertyOption(payload: { property: string; value: string }): void {
    this.setPropOption({ ...payload, ...{ action: 'add' } })
  }

  private setPropOption(payload: { property: string; value: string; action: string }): void {
    let propertyOptionArray = lodash.get(this.model.configurator, payload.property) as Array<string>
    if (!propertyOptionArray) {
      propertyOptionArray = []
      Vue.set(this.model.configurator, payload.property, propertyOptionArray)
    }
    const optionIndex = propertyOptionArray.indexOf(payload.value)
    if (optionIndex < 0 && payload.action !== 'remove') {
      propertyOptionArray.push(payload.value)
    } else if (optionIndex >= 0 && payload.action !== 'add') {
      propertyOptionArray.splice(optionIndex, 1)
    }
  }
}
